// festival ページの宵宮/本宮タブ切り替え
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["tab", "panel"]

  switch(event) {
    const day = event.currentTarget.dataset.day
    this.tabTargets.forEach((t) => t.classList.toggle("active", t.dataset.day === day))
    document.getElementById("day-1").style.display = day === "1" ? "" : "none"
    document.getElementById("day-2").style.display = day === "2" ? "" : "none"
  }
}
